import * as React from "react";
import { useTranslation } from "react-i18next";
import QueryHelper from "components/common/QueryHelper";
const QUERY_EXAMPLE = "description:security";
const TeamsQueryHelp = () => {
  const { t } = useTranslation("enterprise_security");
  const queryExample = /* @__PURE__ */ React.createElement("p", null, t("teams_query_helper.example"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("code", null, QUERY_EXAMPLE), /* @__PURE__ */ React.createElement("br", null));
  return /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "Team", example: queryExample, commonFields: ["name", "description"] });
};
export default TeamsQueryHelp;
